import RestApiModel from "@/api/Model/RestApiModel";
import api from '@/api';

class UserAddress extends RestApiModel {
  static getResourceEndpoint() {
    return '/user/address';
  }

  static getOptions() {
    return api.get(this.getResourceEndpoint() + '/options');
  }

}

export default UserAddress;
